import {createContext, useContext, useState} from "react";

import { UserType } from "types/UserType";

import { StateManagerType } from "./StateManagerType";

import { useRegistartion } from "./useRegistration";
import { useDietanamnez } from "./useDietanamnez";

import { getQueryVariable } from "../getQueryVariable";
import { Data, DataLite } from "types/Data";
import { DietanamnezChartItem } from "types/DietanamnezItem";

type StateManager = Omit<StateManagerType, "screen"> & {
  screen: StateManagerType["screen"] | "ERROR" | "ERROR_TELEGRAM";
  isInitial: boolean;
  setIsInitial: (value: boolean) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  selftestData: Data;
  blob: Blob;
  dietanamnezChartItems: DietanamnezChartItem[];
  parsedSelftestData: DataLite;
  type: "DIETANAMNEZ" | "REGISTRATION";
  userType: UserType;
  telegramTypeError: null | string;
  template: string | null,
  isCountDownWasShown: boolean,
  setIsCountDownWasShown: (isLoading: boolean) => void;
  tokenRegistration: string | undefined;
};

export const StateManagerContext = createContext<StateManager | undefined>(
  undefined
);

/* eslint-disable react-hooks/rules-of-hooks */

export const useStateManager = (): StateManager => {
  const context = useContext(StateManagerContext);

  if (context) {
    return context;
  }

  const userType =
    window.location.pathname === "/p" ? UserType.PRO : UserType.LITE;

  const tokenRegistration = getQueryVariable("r");
  const tokenDietanamnez = getQueryVariable("i");

  const [isInitial, setIsInitial] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selftestData, setSelftestData] = useState<any>(null);
  const [blob, setBlob] = useState<Blob>(new Blob());
  const [dietanamnezChartItems, setDietanamnezChartItems] = useState<DietanamnezChartItem[]>([]);
  const [parsedSelftestData, setParsedSelftestData] = useState<DataLite>({} as DataLite);
  const [telegramTypeError, setTelegramTypeError] = useState<null | string>(null)
  const [template, setTemplate] = useState<null | string>(null)
  const [isCountDownWasShown, setIsCountDownWasShown] = useState<boolean>(false)
  const [isLocalStorageClear, setIsLocalStorageClear] = useState<boolean>(false)

  /*Очистка ls для баланседы*/
  const params = new URLSearchParams(window.location.search);
  if(params.get("clearls") === "true" && !isLocalStorageClear) {
    localStorage.clear();
    setIsLocalStorageClear(true)
  }

  /*useEffect(() => {
    const userAgent = window.navigator.userAgent;
    // Проверка на наличие ключевых слов для Android и ios WebView
    setTelegramTypeError(
        userAgent.includes('Android') && /Chrome/.test(userAgent) && !/Chrome\/\d+\.0\.0\.0/.test(userAgent) && userAgent.includes("Mobile Safari") ? 'android'
              :
              userAgent.includes('iPhone') && /Version/.test(userAgent) && !/Version\/\d+\.\d+(\s|$)/.test(userAgent) && userAgent.includes("Mobile") ? 'ios'
              :
              null
    )
  }, []);*/

  const data = tokenRegistration
    ? useRegistartion(tokenRegistration, userType, setIsLoading, setSelftestData, setDietanamnezChartItems, setBlob, setParsedSelftestData, isInitial, setTemplate)
    : useDietanamnez(tokenDietanamnez!, userType);

  const screen = data.isError ? "ERROR" : telegramTypeError ? "ERROR_TELEGRAM" : data.screen;

  return {
    type: tokenRegistration
      ? ("REGISTRATION" as const)
      : ("DIETANAMNEZ" as const),
    isInitial,
    setIsInitial,
    isLoading,
    setIsLoading,
    selftestData,
    blob,
    dietanamnezChartItems,
    parsedSelftestData,
    userType,
    ...data,
    screen: data.linkInfo || data.isError ? screen : undefined,
    onNextScreen: async (exists = false) => {
      setIsInitial(false);
      await data.onNextScreen(exists);
    },
    onPrevScreen: () => {
      setIsInitial(false);
      data.onPrevScreen();
    },
    telegramTypeError,
    template,
    isCountDownWasShown,
    setIsCountDownWasShown,
    tokenRegistration
  };
};
